let app = "AIM";
let appBuild = "20261027";
let appVer = "V1.1.1";
let site = "越南"

export {
	app,
	appBuild,
	appVer,
	site
}